import { Satellite } from "@material-ui/icons";
import PropTypes from "prop-types";
import { deleteCommand, postCommand, sendCommand } from "../../components/Bridge";
import SessionState from "./SessionState";

const SESSION_ACTIONS = {
  LOAD : "LOAD",
  DATA_UPDATED: "DATA_UPDATED",
  DATA_ADDED: "DATA_ADDED",
  CONFIRM_DELETION: "CONFIRM_DELETION",
  DELETE: "DELETE",
  CATEGORIES_UPDATED: "CATEGORIES_UPDATED",
  ROWS_SELECTION: "ROWS_SELECTION",
  RESULTS_UPDATED: "RESULTS_UPDATED",
  RESULTS_GROUPBY_UPDATED: "RESULTS_GROUPBY_UPDATED",
  CATEGORIZE : "CATEGORIZE",
  BOOKMARK : "BOOKMARK",
  COLUMNS_UPDATED : "COLUMNS_UPDATED",
  OPEN_ROW : "OPEN_ROW",
  TOGGLE_BOOKMARKS : "TOGGLE_BOOKMARKS",
  FILTERS_UPDATED : "FILTERS_UPDATED"
};

const getAllChecked = (data) => {
  let _allChecked = [];
  data.forEach((_row) => {
    if (_row.checked) {
      _allChecked.push(_row);
    }
  });
  return _allChecked;
}
const checkAllChecked = (data) => {
  let rows = getAllChecked(data);
  let _allChecked = rows.length;
  let allChecked = 0;
  if (_allChecked === 0) {
    allChecked = 0;
  }
  else if (_allChecked === data.length) {
    allChecked = 2;
  } else {
    allChecked = 1;
  }
  return allChecked;
}

const BATCH_SIZE = 100;

function SessionReducer(state, action) {
  console.log("SessionReducer:"+action.type, action);
  switch (action.type) {
    case SESSION_ACTIONS.LOAD: {
      let params = action.params;
      sendCommand("session/list", {
          sessionType : params.sessionType,
          hero : params.hero,
          nodeId : params.nodeId,
          sort : params.sort,
          dir : params.dir,
          start : action.batch * BATCH_SIZE,
          limit : BATCH_SIZE
      }).then((response)=>{
        action.callback(response.data);
      });
      return state;
    }
    case SESSION_ACTIONS.DATA_UPDATED: {
      return {
        ...state,
        data : action.payload.data,
        total : action.payload.total,
        categories : action.payload.info,
        selectedRows : getAllChecked(state.data),
        allChecked : checkAllChecked(state.data)
      }
    }
    case SESSION_ACTIONS.DATA_ADDED: {
      let data = state.data;
      action.payload.data.forEach(row => {
        data.push(row);
      });
      return {
        ...state,
        total : action.payload.total,
        data : data,
        categories : action.payload.info,
        allChecked : state.allChecked === 2 ? 1 : state.allChecked === 1 ? 1 : 0
      }
    }
    case SESSION_ACTIONS.CONFIRM_DELETION: {
      return {
        ...state,
        confirmDeletion : action.payload
      }
    }
    case SESSION_ACTIONS.CATEGORIZE: {
      let data= [];
      let ids = action.ids;
      let categoryId= action.categoryId;
      let level= action.level;
      state.data.forEach(row => {
        if (ids.indexOf(row.id) !== -1) {
          row.category = categoryId;
          if (categoryId >= 0) {
            row.categoryColor = "rgba(" + level.red + "," + level.green + "," + level.blue + "," + level.alpha + ")";
          } else {
            row.categoryColor = "transparent";
          }
        }
        data.push(row);
      });
      postCommand("session/categorize", null, {ids : ids.join(), category : categoryId}).then(response=>{
      }).catch(err=>{
        console.error("categorize error", err);
      });
      return {
        ...state,
        data : data
      };
    }
    case SESSION_ACTIONS.TOGGLE_BOOKMARKS:{
      let data= [];
      state.data.forEach(row => {
        if (action.ids.indexOf(row.id) !== -1) {
          row.bookmark = action.bookmark;
        }
        data.push(row);
      });
      postCommand("session/bookmark", null, {ids : action.ids.join(), bookmark :action.bookmark}).then(()=>{
        if(action.callback){
          action.callback();
        }
      });
      return {
        ...state,
        data : data
      };
    }
    case SESSION_ACTIONS.DELETE: {
      let ids = [];
      state.selectedRows.forEach((row) => {
        ids.push(row.id);
      });
      deleteCommand("session/delete", {ids : ids.join()}).then(()=>{
        action.callback();
      }).catch((err)=>{
        console.error("delete error", err);
      });
      return state;
    }
    case SESSION_ACTIONS.CATEGORIES_UPDATED: {
      return {
        ...state,
        categories : action.payload
      }
    }
    case SESSION_ACTIONS.ROWS_SELECTION: {
      let data= [];
      state.data.forEach(row => {
        if (action.payload.ids.indexOf(row.id) !== -1) {
          row.checked = action.payload.checked;
        }
        data.push(row);
      });
      return {
        ...state,
        data : data,
        selectedRows : getAllChecked(state.data),
        allChecked : checkAllChecked(state.data)
      }
    }
    case SESSION_ACTIONS.RESULTS_UPDATED: {
      return {
        ...state,
        results : action.payload
      }
    }
    case SESSION_ACTIONS.COLUMNS_UPDATED:{
      return {
        ...state, 
        columns : action.payload
      };
    }
    case SESSION_ACTIONS.RESULTS_GROUPBY_UPDATED: {
      return {
        ...state,
        resultsGroupBy : action.payload
      }
    }
    case SESSION_ACTIONS.OPEN_ROW:{
      sendCommand("session/replay", {sessionId : action.sessionId, heroId : action.heroId});
      return state;
    }
    case SESSION_ACTIONS.FILTERS_UPDATED:{
      manageFolder(action.payload, -1000);
      return {
        ...state,
        folder : action.payload
      };
    }
    default:{
      console.log("DEFAULT CASE !!!");
      return state;
    }
  }
}

const manageFolder= (folder, lastId)=>{
  if(!folder.id){
    folder.id= lastId-1;
    console.log("folder id", folder.id);
    folder.folders.forEach(child=>manageFolder(child, lastId-1));
  }
}



SessionReducer.propTypes = {
  state: PropTypes.instanceOf(SessionState).isRequired,
  action: PropTypes.string.isRequired
};

export { SESSION_ACTIONS, SessionReducer };
